import { useEffect, useRef, useState } from 'react';
import {
  VariantDescriptionFilterContainer,
  VariantDescriptionFilterContent,
  VariantDescriptionFilterHeading,
  ActiveVariantName,
} from '../../VariantDescription/VariantDescription.styles';
import VariantCta from '../../VariantCta/VariantCta';
import { IS_DESKTOP } from '@/utils/checkClientDeviceType';
import { AddIcon, MinusIcon } from '../../../../../assets/svgExports/AddIcon';

function VariantChips(props) {
  const { item, index, activeVariant } = props;
  const [isOverflowing, setIsOverflowing] = useState(false);
  const [showMore, setShowMore] = useState(false);
  const containerRef = useRef(null);
  useEffect(() => {
    setTimeout(() => {
      const container = containerRef?.current;
      requestAnimationFrame(() => {
        if (container?.scrollHeight > container?.clientHeight) {
          setIsOverflowing(true);
        }
      });
    }, 100);
  }, [containerRef?.current?.scrollHeight, containerRef?.current?.clientHeight]);

  function renderShowMoreLessCTA() {
    const themeColor = props?.storeInfo?.theme?.colors?.primary_color || '#000';
    return (
      <div
        className="tw-mt-[14px] tw-flex tw-cursor-pointer tw-items-center tw-gap-[8px] tw-text-sm tw-font-medium"
        style={{ color: themeColor }}
      >
        <div className="tw-flex tw-items-center tw-gap-[8px]" onClick={toggleShowMore}>
          {!showMore ? <AddIcon color={themeColor} /> : <MinusIcon color={themeColor} />}
          <span>{!showMore ? 'View more' : 'View less'}</span>
        </div>
      </div>
    );
  }

  const toggleShowMore = () => {
    setShowMore(!showMore);
  };

  return (
    <VariantDescriptionFilterContainer key={`variant-category-${Object.keys(item)[0]}`}>
      <VariantDescriptionFilterHeading>
        <div>
          <span>{Object.keys(item)[0]}:</span>
          <ActiveVariantName>
            {props?.activeVariant?.option_variant_names?.[index]?.variant_name || ''}
          </ActiveVariantName>
        </div>
      </VariantDescriptionFilterHeading>
      <VariantDescriptionFilterContent
        isColor={false}
        ref={containerRef}
        style={{
          maxHeight: showMore ? 'none' : IS_DESKTOP ? '90px' : '140px',
          overflow: 'hidden',
          transition: 'max-height 0.3s ease-in-out, overflow 0.3s ease-out',
        }}
      >
        {item[Object.keys(item)[0]].map((item_variants) => {
          return (
            activeVariant && (
              <div key={`specific-variant-${item_variants?.variant_name}`}>
                <VariantCta
                  activeIdx={props?.activeIdx}
                  toggleClick={props?.toggleClick}
                  activeVariantOption={props?.activeVariantOption}
                  activeVariant={props?.activeVariant}
                  outOfVisbleInfo={props?.outOfVisbleInfo}
                  outOfStockInfo={props?.outOfStockInfo}
                  key={`specific-variant-${item_variants?.variant_name}`}
                  variantName={item_variants?.variant_name}
                  rowIndex={index}
                  handleVariantBtnClick={props?.handleVariantBtnClick}
                  returnIsVariantVisible={props?.returnIsVariantVisible}
                  returnIsVariantAvailable={props?.returnIsVariantAvailable}
                  storeInfo={props?.storeInfo}
                />
              </div>
            )
          );
        })}
      </VariantDescriptionFilterContent>
      {isOverflowing && renderShowMoreLessCTA()}
    </VariantDescriptionFilterContainer>
  );
}

export default VariantChips;
